import React, { useMemo } from 'react';
import { Box } from '@mui/material';

export default function RotatingDataCircle() {
  const TOTAL_BARS = 60; 
  const RADIUS = 30;     // Reduje un poco el radio para dar espacio a que las barras crezcan hacia afuera
  const BAR_WIDTH = 1.5; 
  const CENTER = 50;     

  const barHeights = useMemo(() => {
    return Array.from({ length: TOTAL_BARS }, () => {
      return 5 + Math.random() * 15; 
    });
  }, [TOTAL_BARS]);

  return (
    <Box
      sx={{
        width: 150, 
        height: 150,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        animation: 'spin 20s linear infinite',
        '@keyframes spin': {
          '0%': { transform: 'rotate(0deg)' },
          '100%': { transform: 'rotate(360deg)' },
        },
      }}
    >
      <svg viewBox="0 0 100 100" width="100%" height="100%">
        {barHeights.map((height, index) => {
          const angle = (index / TOTAL_BARS) * (2 * Math.PI);

          const x = CENTER + RADIUS * Math.cos(angle);
          const y = CENTER + RADIUS * Math.sin(angle);

          // CAMBIO CLAVE AQUÍ: Restamos 90 en lugar de sumar 90
          const rotationAngle = (angle * 180) / Math.PI - 90;

          return (
            <rect
              key={index}
              x={x - BAR_WIDTH / 2} 
              y={y}
              width={BAR_WIDTH}
              height={height}
              fill="#ffffff" 
              transform={`rotate(${rotationAngle} ${x} ${y})`}
            />
          );
        })}
      </svg>

      <Box 
        sx={{ 
          position: 'absolute', 
          color: '#fff',
          animation: 'spin-reverse 20s linear infinite',
          '@keyframes spin-reverse': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(-360deg)' },
          },
        }}
      >
        ✦
      </Box>
    </Box>
  );
}